var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTypography = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45946 2.8919C4.14601 2.8919 3.8919 3.14601 3.8919 3.45946V4.21622C3.8919 4.73865 3.46838 5.16217 2.94595 5.16217C2.42351 5.16217 2 4.73865 2 4.21622V3.45946C2 2.10114 3.10114 1 4.45946 1H12.027C13.3854 1 14.4865 2.10114 14.4865 3.45946V4.21622C14.4865 4.73865 14.063 5.16217 13.5406 5.16217C13.0181 5.16217 12.5946 4.73865 12.5946 4.21622V3.45946C12.5946 3.14601 12.3405 2.8919 12.027 2.8919H9.56758C9.35864 2.8919 9.1892 3.0613 9.1892 3.27028V12.7297C9.1892 12.9387 9.35864 13.1081 9.56758 13.1081H10.5135C11.036 13.1081 11.4595 13.5317 11.4595 14.0541C11.4595 14.5765 11.036 15 10.5135 15H5.97298C5.45055 15 5.02703 14.5765 5.02703 14.0541C5.02703 13.5317 5.45055 13.1081 5.97298 13.1081H6.91893C7.12787 13.1081 7.29731 12.9387 7.29731 12.7297V3.27028C7.29731 3.0613 7.12787 2.8919 6.91893 2.8919H4.45946Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTypography, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/typography.c59cb6c7.svg";
export { ForwardRef as ReactComponent };